function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _templateObject, _templateObject2, _templateObject3, _templateObject4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
import React from "react";
import styled from "styled-components";
var TRIANGLE_HEIGHT = 8;
var BORDER_OFFSET = 2;
var Box = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral([""])));
var Wrapper = styled(Box)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  display: flex;\n  position: relative;\n"])));
var Toggle = styled(Box)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  display: flex;\n"])));
var Container = styled(Box)(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  position: absolute;\n  top: ", "px;\n  left: 50%;\n  ", "\n  display: ", ";\n  background-color: #ffffff;\n  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.15);\n  z-index: 20;\n  ::before,\n  ::after {\n    position: absolute;\n    ", "\n\n    ", "\n    transform: translateX(-50%);\n    width: 0;\n    height: 0;\n    content: \"\";\n    border-left: ", "px solid transparent;\n    border-right: ", "px solid transparent;\n    ", "\n\n  }\n  ::before {\n    ", "\n    ", "\n  }\n\n  @media all and (-ms-high-contrast: none) {\n    position: absolute;\n     top: ", "px;\n     left: 50%;\n     ", "\n     display: ", ";\n     background-color: #ffffff;\n     box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.15);\n     z-index: 20;\n     border: 1px solid #cccccc;\n     ::before,\n     ::after {\n       position: absolute;\n       ", "\n       ", "\n       transform: translateX(-50%);\n       width: 0;\n       height: 0;\n       content: \"\";\n       border-left: ", "px solid transparent;\n       border-right: ", "px solid transparent;\n       ", "\n\n     }\n     ::before {\n      ", "\n      ", "\n     }\n }\n"])), function (props) {
  return props.offsetHeight;
}, function (props) {
  return props.forceLeft ? "transform: translateX(-100%) translateX(".concat(TRIANGLE_HEIGHT, "px) !important; ") : "transform: translateX(-50%) translateX(".concat(-props.offsetWidth, "px) !important;");
}, function (props) {
  return props.visible ? "block" : "none";
}, function (props) {
  return props.triangleOrientation === 'bottom' ? "bottom: -".concat(TRIANGLE_HEIGHT, "px;") : "top: -".concat(TRIANGLE_HEIGHT, "px;");
}, function (props) {
  return props.forceLeft ? "left: calc(100% - ".concat(TRIANGLE_HEIGHT, "px);") : "left: calc(50% + ".concat(props.offsetWidth, "px);");
}, TRIANGLE_HEIGHT, TRIANGLE_HEIGHT, function (props) {
  return props.triangleOrientation === 'bottom' ? "border-top: ".concat(TRIANGLE_HEIGHT, "px solid rgb(255, 255, 255);") : "border-bottom: ".concat(TRIANGLE_HEIGHT, "px solid rgb(255, 255, 255);");
}, function (props) {
  return props.triangleOrientation === 'bottom' ? "bottom: -".concat(TRIANGLE_HEIGHT + 2, "px;") : "top: -".concat(TRIANGLE_HEIGHT + 2, "px;");
}, function (props) {
  return props.triangleOrientation === 'bottom' ? "border-top: 10px solid rgba(0, 0, 0, 0.15);" : "border-bottom: 10px solid rgba(0, 0, 0, 0.15);";
}, function (props) {
  return props.offsetHeight;
}, function (props) {
  return props.forceLeft ? "transform: translateX(-100%) translateX(".concat(TRIANGLE_HEIGHT, "px) !important; ") : "transform: translateX(-50%) translateX(".concat(-props.offsetWidth, "px) !important;");
}, function (props) {
  return props.visible ? "block" : "none";
}, function (props) {
  return props.triangleOrientation === 'bottom' ? "bottom: -".concat(TRIANGLE_HEIGHT, "px;") : "top: -".concat(TRIANGLE_HEIGHT, "px;");
}, function (props) {
  return props.forceLeft ? "left: calc(100% - ".concat(TRIANGLE_HEIGHT, "px) !important;") : "left: calc(50% + ".concat(props.offsetWidth, "px) !important;");
}, TRIANGLE_HEIGHT, TRIANGLE_HEIGHT, function (props) {
  return props.triangleOrientation === 'bottom' ? "border-top: ".concat(TRIANGLE_HEIGHT, "px solid rgb(255, 255, 255);") : "border-bottom: ".concat(TRIANGLE_HEIGHT, "px solid rgb(255, 255, 255);");
}, function (props) {
  return props.triangleOrientation === 'bottom' ? "bottom: -".concat(TRIANGLE_HEIGHT + 2, "px;") : "top: -".concat(TRIANGLE_HEIGHT + 2, "px;");
}, function (props) {
  return props.triangleOrientation === 'bottom' ? "border-top: 10px solid rgba(0, 0, 0, 0.15);" : "border-bottom: 10px solid rgba(0, 0, 0, 0.15);";
});
var Tooltip = /*#__PURE__*/function (_React$Component) {
  _inherits(Tooltip, _React$Component);
  var _super = _createSuper(Tooltip);
  function Tooltip(props) {
    var _this;
    _classCallCheck(this, Tooltip);
    _this = _super.call(this, props);
    _defineProperty(_assertThisInitialized(_this), "setWrapperRef", function (element) {
      _this.wrapperElement = element;
    });
    _defineProperty(_assertThisInitialized(_this), "setToggleRef", function (element) {
      _this.toggleElement = element;
    });
    _defineProperty(_assertThisInitialized(_this), "setContainerRef", function (element) {
      _this.containerElement = element;
    });
    _defineProperty(_assertThisInitialized(_this), "setOffsetHeight", function (offsetHeight, triangleOrientation) {
      if (_this.state.offsetHeight !== offsetHeight) {
        _this.updateStateIfMounted({
          offsetHeight: offsetHeight,
          isTransformed: true,
          triangleOrientation: triangleOrientation
        });
      }
    });
    _defineProperty(_assertThisInitialized(_this), "setOffsetWidth", function (offsetWidth) {
      if (_this.state.offsetWidth !== offsetWidth) {
        _this.updateStateIfMounted({
          offsetWidth: offsetWidth,
          isTransformed: true
        });
      }
    });
    _defineProperty(_assertThisInitialized(_this), "handleCloseElement", function (element) {
      if (element.dataset.close) {
        element.click();
        _this.updateStateIfMounted({
          isOpen: false
        });
      }
    });
    _defineProperty(_assertThisInitialized(_this), "handleOutsideClick", function (event) {
      if (!_this.state.isOpen) {
        return;
      }
      _this.handleCloseElement(event.target);
      if (_this.toggleElement && !_this.wrapperElement.contains(event.target)) {
        _this.updateStateIfMounted({
          isOpen: false
        });
      }
    });
    _defineProperty(_assertThisInitialized(_this), "wrapperElement", null);
    _defineProperty(_assertThisInitialized(_this), "toggleElement", null);
    _defineProperty(_assertThisInitialized(_this), "containerElement", null);
    _defineProperty(_assertThisInitialized(_this), "closeTimeout", null);
    _defineProperty(_assertThisInitialized(_this), "openMenuOnHover", function (event) {
      event.preventDefault();
      event.stopPropagation();
      _this.updateStateIfMounted(function (prevState) {
        return {
          isOpen: true,
          isTransformed: false,
          offsetHeight: 0,
          offsetWidth: 0
        };
      });
      return false;
    });
    _defineProperty(_assertThisInitialized(_this), "closeMenu", function () {
      _this.updateStateIfMounted(function (prevState) {
        return {
          isOpen: false,
          isTransformed: false,
          offsetHeight: 0,
          offsetWidth: 0
        };
      });
    });
    _defineProperty(_assertThisInitialized(_this), "calculateOffsets", function () {
      var _this$containerElemen = _this.containerElement.getBoundingClientRect(),
        left = _this$containerElemen.left,
        right = _this$containerElemen.right,
        height = _this$containerElemen.height;
      var _this$toggleElement$g = _this.toggleElement.getBoundingClientRect(),
        topToggle = _this$toggleElement$g.top,
        bottomToggle = _this$toggleElement$g.bottom;
      var boundingElementRect = _this.props.boundingElement ? _this.props.boundingElement.getBoundingClientRect() : {
        left: 0,
        top: 0,
        right: window.innerWidth,
        bottom: window.innerHeight
      };

      // Special fix for the footer
      height += 40;
      var rightBound = boundingElementRect.right,
        leftBound = boundingElementRect.left,
        topBound = boundingElementRect.top,
        bottomBound = boundingElementRect.bottom;
      if (right > rightBound) {
        var offsetWidth = right - rightBound + BORDER_OFFSET - _this.state.correctionWidthOffset;
        _this.setOffsetWidth(offsetWidth);
      } else if (left < leftBound) {
        var _offsetWidth = -Math.abs(leftBound - left - BORDER_OFFSET + _this.state.correctionWidthOffset);
        _this.setOffsetWidth(_offsetWidth);
      }
      if (_this.props.prioritizeTop) {
        if (topToggle - height < topBound) {
          _this.setOffsetHeight(_this.toggleElement.offsetHeight + TRIANGLE_HEIGHT, 'top');
        } else if (bottomToggle + height > bottomBound) {
          _this.setOffsetHeight(-_this.containerElement.offsetHeight - TRIANGLE_HEIGHT, 'bottom');
        }
      } else {
        if (_this.props.allowTop) {
          if (bottomToggle + height > bottomBound) {
            _this.setOffsetHeight(-_this.containerElement.offsetHeight - TRIANGLE_HEIGHT, 'bottom');
          } else {
            if (topToggle - height < topBound) {
              _this.setOffsetHeight(_this.toggleElement.offsetHeight + TRIANGLE_HEIGHT, 'top');
            }
          }
        } else {
          _this.setOffsetHeight(_this.toggleElement.offsetHeight + TRIANGLE_HEIGHT, 'top');
        }
      }
    });
    _this.state = {
      isOpen: false,
      isTransformed: false,
      triangleOrientation: 'top',
      offsetHeight: 0,
      offsetWidth: 0,
      correctionWidthOffset: props.correctionWidthOffset || 0
    };
    _this._isMounted = false;
    return _this;
  }
  _createClass(Tooltip, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      document.addEventListener("mousedown", this.handleOutsideClick);
      document.addEventListener("touchstart", this.handleOutsideClick);
      this._isMounted = true;
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      if (this.toggleElement && !this.state.isTransformed) {
        if (this.props.prioritizeTop) {
          this.setOffsetHeight(-this.containerElement.offsetHeight - TRIANGLE_HEIGHT, 'bottom');
        } else {
          this.setOffsetHeight(this.toggleElement.offsetHeight + TRIANGLE_HEIGHT, 'top');
        }
      }
      if (this.containerElement && !this.props.center && !this.state.isTransformed) {
        this.calculateOffsets();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      document.removeEventListener("mousedown", this.handleOutsideClick);
      document.removeEventListener("touchstart", this.handleOutsideClick);
      if (this.closeTimeout) {
        clearTimeout(this.closeTimeout);
      }
      this._isMounted = false;
    }
  }, {
    key: "updateStateIfMounted",
    value: function updateStateIfMounted(newState) {
      if (this._isMounted) {
        this.setState(newState);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var openModuleProps = {
        onMouseEnter: this.openMenuOnHover,
        onMouseLeave: this.closeMenu
      };
      return /*#__PURE__*/React.createElement(Wrapper, {
        ref: this.setWrapperRef
      }, /*#__PURE__*/React.createElement(Toggle, _extends({}, openModuleProps, {
        ref: this.setToggleRef
      }), this.props.toggleElement), /*#__PURE__*/React.createElement(Container, {
        visible: this.state.isOpen,
        offsetHeight: this.props.fixedTop ? this.props.fixedTop : this.state.offsetHeight,
        offsetWidth: this.state.offsetWidth,
        offsetWidthTriangle: this.state.offsetWidthTriangle,
        ref: this.setContainerRef,
        forceLeft: this.props.forceLeft,
        triangleOrientation: this.state.triangleOrientation
      }, this.state.isOpen && this.props.containerElement));
    }
  }]);
  return Tooltip;
}(React.Component);
export default Tooltip;